export default "__VITE_ASSET__BKT79OU9__"